import axios from "axios";

const API_URL = "/api/vehicle/reportcode";

export function checkReportCode(licensePlate, reportCode) {
  return axios.get(`${API_URL}/${licensePlate}`, {
    params: {reportCode: reportCode}
  }).then(result => result.data);
}
